import { useEffect, useMemo } from 'react';

import { useBonusesContext } from 'src/components/BonusesProvider';

export const useDepositAmounts = ({
  currency,
  depositAmountTemplate,
  paymentMethod,
  preselectedPaymentMethod,
  ref,
}) => {
  const { setDepositAmount } = useBonusesContext();
  const depositAmounts = useMemo(() => {
    const amountsByCurrency = depositAmountTemplate[currency];

    if (amountsByCurrency?.length && typeof amountsByCurrency[0] !== 'object') {
      return amountsByCurrency.map(val => ({
        isDefault: false,
        value: val,
      }));
    }

    return amountsByCurrency;
  }, [currency, depositAmountTemplate]);

  const defaultDepositAmount = useMemo(
    () => depositAmounts?.find(amount => amount.isDefault),
    [depositAmounts],
  );

  useEffect(() => {
    if (paymentMethod && !preselectedPaymentMethod && !defaultDepositAmount) {
      setDepositAmount(null);
      ref.current?.setFieldValueHandler?.('amount', null);
    }
  }, [defaultDepositAmount, paymentMethod, preselectedPaymentMethod, setDepositAmount, ref]);

  return { defaultDepositAmount, depositAmounts };
};
